import React from 'react';
import { CategoryMapping } from 'services/categoryMappingService';
import AspectRow from './AspectRow';
import { stripCategoryPrefix } from './helpers';

interface CategorySectionProps {
  mapping: CategoryMapping;
  globalRowStart: number;
  colSpan: number;
  expandAllToken: number;
  collapseAllToken: number;
}

/**
 * Renders a dark header row for the category + rubric, followed by
 * one AspectRow per aspect in the rubric.
 */
const CategorySection: React.FC<CategorySectionProps> = ({
  mapping,
  globalRowStart,
  colSpan,
  expandAllToken,
  collapseAllToken,
}) => {
  const aspects = mapping.rubric?.aspects ?? [];

  return (
    <>
      {/* Category header row */}
      <tr
        id={`category-row-${mapping.categoryName}`}
        className="bg-gray-800 text-white"
      >
        <td colSpan={colSpan} className="px-3 py-2">
          <div className="flex items-center gap-3 flex-wrap">
            <span className="text-sm font-extrabold font-baijamjuree">
              {mapping.categoryName}
            </span>
            <span className="text-xs text-gray-300 font-baijamjuree">
              (ProjectID: {mapping.projectDocumentId}) (RubricID:{' '}
              {mapping.rubric?.documentId || 'N/A'})
            </span>
          </div>
        </td>
      </tr>

      {/* Aspect rows */}
      {aspects.length === 0 ? (
        <tr>
          <td
            colSpan={colSpan}
            className="px-4 py-3 text-xs text-gray-400 italic border-b border-gray-200"
          >
            No aspects defined.
          </td>
        </tr>
      ) : (
        aspects.map((aspect, ai) => (
          <AspectRow
            key={aspect.documentId}
            aspect={aspect}
            categoryName={mapping.categoryName}
            rowNum={globalRowStart + ai}
            colSpan={colSpan}
            isLast={ai === aspects.length - 1}
            expandAllToken={expandAllToken}
            collapseAllToken={collapseAllToken}
          />
        ))
      )}
    </>
  );
};

export default CategorySection;
